import React, {
  useState,
  useCallback,
  useContext,
  useMemo,
  useEffect,
} from "react";
import ItemLibrary from "../ItemLibrary/ItemLibrary";
import ModalDetail from "../ModalDetail/ModalDetail";
import { AuthenticationContext } from "../AuthenticationContextProvider";
import { useRouteMatch } from "react-router-dom";
import { LocaleContext } from "../../components/LocaleContextProvider";
import { ConfigContext } from "../../components/ConfigContextProvider";
import { IntlProvider, FormattedMessage } from "react-intl";
import { injectIntl, intlShape } from "react-intl";
import ReactTooltip from "react-tooltip";

const tabVisibleCounts = {};

const Library = (props) => {
  const { PRODUCTS_URL } = useContext(ConfigContext);
  const { favorites, setFavorites, userOptions } = useContext(
    AuthenticationContext
  );
  const { locale } = useContext(LocaleContext);
  const { dataList } = props;

  const [detail, setDetail] = useState(null);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [products, setProducts] = useState(null);

  const allItems = useMemo(() => {
    if (!products) return [];
    if (products.sorting) return products.sorting.flatMap(g => g.items);
    return products.items || [];
  }, [products]);

  const currentIdx = useMemo(() => {
    if (!detail || !allItems.length) return -1;
    return allItems.findIndex(item => item.detail && item.detail.id === detail.id);
  }, [detail, allItems]);
  const numberFavorites = userOptions.numberFavorites || 5;
  const [tooltipMsg, setTooltipMsg] = useState(null);

  const loadMore = !!window.LIBRARY_LOAD_MORE;
  const ROWS_PER_PAGE = 3;
  const getItemsPerRow = () => {
    const w = window.innerWidth;
    if (w >= 1280) return 6;
    if (w >= 1024) return 5;
    if (w >= 768) return 4;
    if (w >= 480) return 2;
    return 1;
  };
  const tabKey = `${props.type?.url}-${props.category?.url || ''}-${props.order?.url || ''}`;
  const [visibleCount, setVisibleCount] = useState(
    !loadMore ? Infinity :
    tabVisibleCounts[tabKey] !== undefined ? tabVisibleCounts[tabKey] : getItemsPerRow() * ROWS_PER_PAGE
  );

  useEffect(() => {
    tabVisibleCounts[tabKey] = visibleCount;
  }, [visibleCount, tabKey]);

  useEffect(() => {
    if (modalIsOpen) document.body.style.overflow = "hidden";
    if (!modalIsOpen) document.body.style.overflow = "unset";
  }, [modalIsOpen]);

  const afterOpenModal = useCallback(() => {
    setIsOpen(true);
  });

  const openModal = useCallback(() => {
    setIsOpen(true);
  });

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setDetail(null);
  });

  const isFavorite = useCallback((obj) => {
    const filtered = favorites.filter((item) => item.name === obj.name);
    return filtered.length > 0;
  });

  const toggleFavorite = useCallback((obj) => {

    console.log("--->toggle")
    let updateFavorites = [...favorites];
    const filtered = favorites.filter((item) => item.name === obj.name);
    if (filtered.length > 0) {
      updateFavorites = favorites.filter((item) => item.name !== obj.name);
    } else {
      updateFavorites.push(obj);
    }
    setFavorites(updateFavorites);
    localStorage.setItem("favorites", JSON.stringify(updateFavorites));

    let sendObj =  {
      event: "select_sample",   
      category: obj.name,  
      action: props.type.url, 
      label: props.category.url
    }
    window.sendToGTM && window.sendToGTM(sendObj)
  
    console.log(sendObj)


  });


  

  //const {items, currentSelected} = props;
  const openDetailHandler = useCallback((detail) => {
    setDetail(detail);
    setIsOpen(true);
  });

  const openDetailHandlerFromModal = useCallback(
    (target) => {
      let next;
      let group;

      if (products && products.items) {
        next = products.items.filter((item) => item.id === target.id)[0];
      }

      if (products.sorting) {
        group = products.sorting.filter((group) => {
          return group.items.filter((item) => item.id === target.id).length > 0;
        });
        if (group) {
          next = group[0].items.filter((item) => item.id === target.id)[0];
        }
      }

      if (next && next.detail) {
        console.log("---> click", next.detail);
        setIsOpen(true);
        setDetail(next.detail);
      }
    },
    [products]
  );

  const onPrev = useCallback(() => {
    if (currentIdx > 0) {
      const prevItem = allItems[currentIdx - 1];
      if (prevItem && prevItem.detail) setDetail(prevItem.detail);
    }
  }, [currentIdx, allItems]);

  const onNext = useCallback(() => {
    if (currentIdx < allItems.length - 1) {
      const nextItem = allItems[currentIdx + 1];
      if (nextItem && nextItem.detail) setDetail(nextItem.detail);
    }
  }, [currentIdx, allItems]);

  //useffect
  const loadGallery = (item) => {
    if (!item) return;
    fetch(
      `${PRODUCTS_URL}${item.query}_${userOptions.userprofile}_${locale}.json`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          //console.log(result)
          setProducts(result);
          //setUserOptions(result.settings)
        },
        (error) => {
          setProducts([]);
        }
      );
  };

  const showTooltip = (item, msg) => {
    // window.addEventListener('scroll', () => {
    //   hideTooltip();
    // });
    setTooltipMsg(msg);
    ReactTooltip.show(item);
  };
  const hideTooltip = (item) => {
    ReactTooltip.hide();
    // setTimeout(
    // ReactTooltip.hide(item), 1000);
  };

  useEffect(() => {
    let selection = props.order || props.category || props.type;
    loadGallery(selection);
  }, []);

  const msgDisabled = props.intl.formatMessage({
    id: "tooltip.item.disable.maxItems",
  });
  const msgDisabledByState = props.intl.formatMessage({
    id: "tooltip.item.disable.sendRequest",
  });

  const renderItem = (item, key, isDisabled, isFavoriteItem, isDisablebByState) => (
    <ItemLibrary
      item={item}
      key={key}
      disablebByState={isDisablebByState}
      disabled={isDisabled}
      favorite={isFavoriteItem}
      toggleFavorite={toggleFavorite}
      showTooltip={showTooltip}
      hideTooltip={hideTooltip}
      onClick={openDetailHandler}
      tooltip={
        isDisablebByState ? msgDisabledByState : isDisabled ? msgDisabled : ""
      }
    />
  );

  const totalItems = products
    ? products.sorting
      ? products.sorting.reduce((acc, g) => acc + g.items.length, 0)
      : (products.items || []).length
    : 0;
  const hasMore = loadMore && totalItems > visibleCount;

  return (
    <>
      <div className="library__wrapper">
        <div className="library__container">
          <div className="container">
            {products && products.sorting && (() => {
              let shown = 0;
              return products.sorting.map((group, g) => {
                if (shown >= visibleCount) return null;
                const visibleItems = group.items.filter(() => shown++ < visibleCount);
                if (!visibleItems.length) return null;
                return (
                  <div className="groupLibrary" key={"group" + g}>
                    <h3 className="groupLibrary__name">{group.name}</h3>
                    <ul className="libraryList">
                      {visibleItems.map((item, i) => {
                        let isFavoriteItem = isFavorite(item);
                        let isDisabled = !isFavoriteItem && favorites.length >= numberFavorites;
                        let isDisablebByState = item.state === "0";
                        return renderItem(item, group.name + g + "_" + i, isDisabled, isFavoriteItem, isDisablebByState);
                      })}
                    </ul>
                  </div>
                );
              });
            })()}

            <ul className="libraryList">
              {products &&
                products.items &&
                products.items.slice(0, visibleCount).map((item, i) => {
                  let isFavoriteItem = isFavorite(item);
                  let isDisabled = !isFavoriteItem && favorites.length >= numberFavorites;
                  let isDisablebByState = item.state == "0";
                  return renderItem(item, item.name + "_" + i, isDisabled, isFavoriteItem, isDisablebByState);
                })}
            </ul>

            {hasMore && (
              <div className="loadMore__wrapper">
                <button
                  className="loadMore__btn"
                  onClick={() => setVisibleCount(Infinity)}
                >
                  <FormattedMessage id={"label.loadmore"} />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <ReactTooltip
        className="tooltipSpecial"
        place="bottom"
        scrollHide={true}
        html={true}
        clickable
        multiline
      >
        {tooltipMsg}
      </ReactTooltip>

      {detail && (
        <ModalDetail
          detail={detail}
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          onClick={openDetailHandlerFromModal}
          onPrev={currentIdx > 0 ? onPrev : null}
          onNext={currentIdx < allItems.length - 1 ? onNext : null}
        />
      )}
    </>
  );
};

export default injectIntl(Library);
